import { Button, CardActions, CircularProgress, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

const DealFormActions = ({ disabled }) => {
	const theme = useTheme();
	const { isSubmitting, values, errors, touched } = useFormikContext();

	return (
		<CardActions
			sx={{
				position: 'sticky',
				bottom: 0,
				zIndex: 1,
				backgroundColor: theme.palette.background.paper,
				borderTop: `1px solid ${theme.palette.divider}`,
				// p: 2,
				justifyContent: 'center',
			}}
		>
			<Button
				color='primary'
				type='submit'
				onClick={() =>
					console.log('FORMIK VALUES BEFORE SUBMIT', { values, errors, touched })
				}
				variant='contained'
				disabled={disabled}
			>
				{isSubmitting ? (
					<CircularProgress size='2em' sx={{ color: '#ffffff' }} />
				) : (
					'Submit'
				)}
			</Button>
		</CardActions>
	);
};
export default DealFormActions;
